<script>
import { mapState, mapMutations } from 'vuex';
import { mutationTypes } from '../../types';
import { uiStates } from '../../tools/viewState';

export default {
	data: function() {
		return {
			name: 'stub',
			mounted: false,
			lastFocusedElement: null,
		};
	},
	props: {
		isSubComponent: {
			type: Boolean,
			default: false,
			required: false,
		},
	},
	computed: {
		...mapState(['viewState']),
		isOpen() {
			if (this.isSubComponent) return;
			return this.viewState[this.name].uiState !== uiStates.hidden && this.mounted;
		},
	},
	methods: {
		...mapMutations([mutationTypes.viewStateSetUiState]),
		close() {
			if (this.isSubComponent) return;
			if (this.customClose) return this.customClose();
			this.viewStateSetUiState({ id: this.name, uiState: uiStates.hidden });
		},
		// set focus after clossing menu to the last focuselement in most cases this will be the menu open button
		closeAndResetFocus() {
			this.lastFocusedElement.focus();
			this.close();
		},
		maximise() {
			if (this.isSubComponent) return;
			this.viewStateSetUiState({ id: this.name, uiState: uiStates.maximised });
			this.isMinimized = false;
		},
		minimise() {
			if (this.isSubComponent) return;
			this.viewStateSetUiState({ id: this.name, uiState: uiStates.minimized });
			this.isMinimized = true;
		},
	},
	mounted() {
		this.mounted = true;
		this.lastFocusedElement = document.activeElement;
	},
	beforeDestroy() {
		this.mounted = false;
	},
};
</script>
